const messages = {
  title: 'Ups! Zašto ste ovdje?',
  description:
    'Jako nam je žao zbog neugodnosti. Izgleda da pokušavate\n' +
    'pristupiti stranici koja je ili obrisana ili nikada nije postojala.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
